import { IDs } from '../../../helpers/IDs';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { validateFieldUniversal } from '../functions/validateField';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';

export interface StandorteMaschinenJahreswerteProps {
    maschineSelected: any;
}

export class StandorteMaschinenJahreswerte extends React.Component<StandorteMaschinenJahreswerteProps, {}> {

    constructor(props: any) {
        super(props);
        this.state = {};
        this.preFilter = this.preFilter.bind(this);
        this.validateField = this.validateField.bind(this);
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    preFilter(data: Array<any>): Array<any> {
        const { maschineSelected } = this.props;

        return maschineSelected
            ? data.filter((item: any) => (+item.maschinen_tid_orig || null) === maschineSelected.tid)
            : data;
    }

    render(): JSX.Element {
        const { maschineSelected } = this.props;
        // console.log('Maschine: ', maschineSelected);
        return (
            <WFormsTableWrapper
                entity={IDs.ENT_MASCHINEN_JAHRESWERTE}
                module={IDs.MOD_ETOOL}
                actions={['add', 'edit', 'delete']}
                customClass='Custom-ETA'
                formLayout='flowV2'
                addLabel='Neues Jahr anlegen'
                formPreset={{ maschinen_tid: maschineSelected.tid }}
                customFormConfig={{
                    maschinen_tid: {
                        readonly: true
                    }
                    // messwert_unterzaehler: {
                    //     readonly: maschineSelected.unterzaehler_vorhanden !== 1
                    // }
                }}
                validateField={this.validateField}
                preFilterFunction={this.preFilter}
                onSaveDone={() => this.triggerService.fire('reload', IDs.ENT_MASCHINEN_JAHRESWERTE)}
            />
        );
    }

    validateField(key: string, value: any, data: any, onValueChange: (name: string, value: any) => void): string {
        return validateFieldUniversal(IDs.ENT_MASCHINEN_JAHRESWERTE, key, value, data, onValueChange);
    }
}
